import React from 'react'

const DoubleCheckIcon = () => {
    return (
        <svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.7814 2.1439C13.0431 1.88221 13.0431 1.45795 12.7814 1.19626C12.5197 0.93458 12.0954 0.93458 11.8338 1.19626L4.71589 8.31412L2.1439 5.74215C1.88221 5.48048 1.45794 5.48048 1.19626 5.74215C0.934579 6.00382 0.93458 6.42811 1.19626 6.68978L4.24208 9.73556C4.50376 9.99729 4.92803 9.99729 5.18971 9.73556L12.7814 2.1439Z" fill="black" stroke="black" strokeWidth="0.5" />
            <path d="M16.8037 2.1439C17.0654 1.88221 17.0654 1.45795 16.8037 1.19626C16.542 0.93458 16.1178 0.93458 15.856 1.19626L8.26436 8.78793C8.0027 9.04966 8.0027 9.47389 8.26436 9.73556C8.52603 9.99729 8.95032 9.99729 9.21199 9.73556L16.8037 2.1439Z" fill="black" stroke="black" strokeWidth="0.5" />
        </svg>

    )
}

export default DoubleCheckIcon
